import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { Reveal, Lines } from "../components/site/Motion";

export default function PrivacyPage() {
  const [terms, setTerms] = useState(null);

  useEffect(() => {
    document.title = "Privacy e note legali — SWAPA";
    const meta = document.querySelector('meta[name="description"]');
    if (meta) meta.setAttribute("content", "Privacy e note legali di swapa.it: prenotazione SWAPA ZIP, diritto di recesso, venditore e trattamento dei dati personali.");
    api.get("/config").then((r) => setTerms(r.data.terms)).catch(() => {});
  }, []);

  return (
    <div data-testid="privacy-page" className="bg-ink pb-28 pt-32 sm:pt-40">
      <div className="mx-auto max-w-3xl px-5 sm:px-10">
        <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-swapa-yellow">Legale</p>
        <h1 className="mt-6 font-display font-black uppercase leading-[0.9] tracking-tighter">
          <Lines animate="load" lines={["Privacy e", "note legali."]} className="text-4xl text-white sm:text-6xl" />
        </h1>
        <Reveal delay={0.25}>
          <div className="mt-12 space-y-8 text-sm leading-relaxed text-zinc-400">
            <p>
              Per esercitare il diritto di recesso sulla prenotazione online:{" "}
              <Link to="/recesso" data-testid="privacy-withdrawal-link" className="text-swapa-yellow underline underline-offset-4">
                Recedere dal contratto qui
              </Link>
            </p>
            <p className="border border-dashed border-zinc-700 p-5 font-mono text-xs uppercase tracking-[0.15em] text-zinc-500">
              Contenuto placeholder — solo staging. I testi legali definitivi (privacy policy,
              termini di preordine, identità del venditore) saranno forniti dal cliente prima
              della pubblicazione.
            </p>
            {terms && (
              <>
                <section><h2 className="font-display text-lg font-bold uppercase text-white">Rimborsabilità della caparra</h2><p className="mt-2">{terms.refundable}</p></section>
                <section><h2 className="font-display text-lg font-bold uppercase text-white">Cancellazione</h2><p className="mt-2">{terms.cancellation}</p></section>
                <section><h2 className="font-display text-lg font-bold uppercase text-white">Detrazione dal prezzo finale</h2><p className="mt-2">{terms.deduction}</p></section>
                <section><h2 className="font-display text-lg font-bold uppercase text-white">Consegna stimata</h2><p className="mt-2">{terms.delivery}</p></section>
                <section><h2 className="font-display text-lg font-bold uppercase text-white">Venditore</h2><p className="mt-2">{terms.seller}</p></section>
                <section><h2 className="font-display text-lg font-bold uppercase text-white">Termini contrattuali</h2><p className="mt-2">{terms.terms_text}</p></section>
              </>
            )}
          </div>
        </Reveal>
      </div>
    </div>
  );
}
